import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface DirectMessage {
  id: string;
  senderId: string;
  receiverId: string;
  content: string;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
  sender?: {
    id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
  receiver?: {
    id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
}

export interface Conversation {
  userId: string;
  partner: {
    id: string;
    username: string;
    firstName?: string;
    lastName?: string;
    avatar?: string;
  };
  lastMessage: {
    id: string;
    content: string;
    senderId: string;
    createdAt: string;
  } | null;
  unreadCount: number;
}

export interface CreateMessagePayload {
  receiverId: string;
  content: string;
}

export const messagesService = {
  async getConversations(params?: { limit?: number; offset?: number }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/messages/conversations`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit: 50, offset: 0, ...params },
    });
    return res.data as {
      conversations: Conversation[];
      pagination: { total: number; limit: number; offset: number; hasMore: boolean };
    };
  },

  async getConversation(userId: string, params?: { limit?: number; offset?: number }) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/messages/conversation/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit: 50, offset: 0, ...params },
    });
    return res.data as {
      messages: DirectMessage[];
      pagination: { total: number; limit: number; offset: number; hasMore: boolean };
    };
  },

  async sendMessage(payload: CreateMessagePayload) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/messages`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: DirectMessage };
  },

  async markAsRead(messageId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/messages/${messageId}/read`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },

  async deleteMessage(messageId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/messages/${messageId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },
};


